/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWebContentRequest } from '../../models/create-web-content-request';
import { WebContentResponse } from '../../models/web-content-response';

export interface CreateWebContent$Params {
      body: CreateWebContentRequest
}

export function createWebContent(http: HttpClient, rootUrl: string, params: CreateWebContent$Params, context?: HttpContext): Observable<StrictHttpResponse<WebContentResponse>> {
  const rb = new RequestBuilder(rootUrl, createWebContent.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WebContentResponse>;
    })
  );
}

createWebContent.PATH = '/v0/web-contents';
